<template>
  <div class="flex_center sc_box">
    <div class="flex_start">
      <div class="left_box flex_colum flex_center_align flex_center">
        <img class="icon" src="~@/assets/images/sc_icon1.png" />
        <span class="word sub">横スクロール</span>
      </div>
      <div class="right_box flex_space flex_center flex_center_align">
        <span class="move_left word flex_center_align" @click="scroll('left')">
          一番左へ移動
        </span>
        <div class="move_center flex_space">
          <div
            class="icon_box flex_center_align flex_center"
            @click="scroll('sleft')"
          >
            <img class="icon" src="~@/assets/images/sc_icon2.png" />
          </div>
          <div
            class="icon_box flex_center_align flex_center"
            @click="scroll('sright')"
          >
            <img class="icon" src="~@/assets/images/sc_icon3.png" />
          </div>
        </div>
        <span
          class="move_right word flex_center_align"
          @click="scroll('right')"
        >
          一番右へ移動
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'VabTableScroll',
    methods: {
      scroll(type) {
        this.$parent.setScrol(type)
      },
    },
  }
</script>

<style lang="scss" scoped>
  .sc_box {
    z-index: $base-z-index - 5;
    position: absolute;
    bottom: -50px;
    left: 50%;
    margin-left: -215px;
    .left_box {
      width: 96px;
      height: 50px;
      background: rgba(0, 0, 0, 0.7);
      border-radius: 4px 0px 0px 4px;
    }

    .word {
      font-weight: 400;
      font-size: 12px;
      text-align: center;
      color: #ffffff;

      &.sub {
        padding-top: 5px;
      }
    }
    .right_box {
      height: 50px;
      background: rgba(0, 0, 0, 0.7);
      border-radius: 0px 4px 4px 0px;
      cursor: pointer;
      padding: 0 25px;
      margin-left: 1px;
      .move_left {
        padding-left: 20px;
        background: url('~@/assets/images/sc_icon2.png') left center no-repeat;
        height: 50px;
      }
      .move_right {
        padding-right: 20px;
        background: url('~@/assets/images/sc_icon3.png') right center no-repeat;
        height: 50px;
      }
      .move_center {
        width: 120px;
        cursor: pointer;
        margin: 0 10px;
        .icon_box {
          width: 50px;
          height: 50px;
        }
      }
    }
  }
</style>
